<template>
<div class="completed main__completed">
	<div class="inner">

		<div class="lead">
			<p class="lead__txt">
				貴重なご意見まことに<br>ありがとうございます。
			</p>
			<a v-if="isYappli && !withinExpire" class="btn is-point" href="https://crm.yapp.li/CC40B910/t/1693892446477/surveypoint" target="_blank">ポイントを獲得</a>
		</div>
		
		<!-- google口コミリンク -->
		<div v-if="result.gbp_review_url" class="review">
			<div class="review__box">
				<h2 class="review__tit">
					<img src="/q/assets/img/logo_google.svg" alt="Google">クチコミ
				</h2>
				<a :href="gdpReviewUrl" target="_blank" class="btn is-link review__btn">レビューを投稿する</a>
				<p class="review__txt">図々しいお願いで恐縮ですが、<br>レビューへのご協力もぜひ！</p>
			</div>
		</div>

		<!-- 店舗リンク -->
		<dl class="toshop" v-if="result.official_url">
			<dt class="toshop__tit">公式店舗情報はこちらから</dt>
			<dd class="toshop__link">
				<a :href="officialUrl" target="_blank">{{ result.shop_name }}</a>
			</dd>
		</dl>

	</div>
</div>
</template>

<script>
import Btn from '../components/Btn.vue';

export default {
	components: {
		Btn,
	},

	props: {
		shopId: {
			type: String,
			default: ''
		},
		result: {
			type: Object,
			default: {}
		},
		isYappli: {
            type: Boolean,
            default: false
        }
	},

	data() {
		return {
			withinExpire: false
		}
	},

	computed: {
		// google口コミのURL
		gdpReviewUrl() {
			if (!this.result.gbp_review_url) return;
			return this.targetBlankInYappli(this.result.gbp_review_url);
		},

		// 店舗のURL
		officialUrl() {
			if (!this.result.official_url) return;
			return this.targetBlankInYappli(this.result.official_url);
		},
	},

	methods: {
		// アプリの場合別タブ用のURLを返す
		targetBlankInYappli(url) {
			if (!url) return;
			if (this.isYappli) return encodeURI(`native:/action/open_browser?url=${url}`);
			return encodeURI(url);
		},

		// ローカルストレージに店舗IDとUUIDを保存 (重複回答防止)
		setUuidToStorage() {
			this.setWithinExpireFlag();
			this.setWithExpiry('respondent', this.shopId, uuid, 4); //UUIDを保存
		},

		//再表示フラグが期限内であればdataに反映
		setWithinExpireFlag() {
			const respondent = localStorage.getItem('respondent'); //uuidデータ
			if (!respondent) return;

			const now = new Date().getTime(); //現在時刻
			const expireData = JSON.parse(respondent); //データをJSONに変換
			if (now < expireData['expire']) this.withinExpire = true; //フラグ立てる
			// console.log(this.withinExpire);
		},

		/**
		 * ローカルストレージにJSONを保存
		 * @param {string} key キー
		 * @param {String} id 店舗ID
		 * @param {String} value 中身(uuid)
		 * @param {Number} expire 期限(時)
		 * 
		*/
		setWithExpiry(key, id, value, expire) {
			// expire = new Date().getTime() + 1000; //テスト（1秒）
			expire = new Date().getTime() + expire * 3600 * 1000;
			const item = {
				id: id,
				value: value,
				expire: expire,
			};
			localStorage.setItem(key, JSON.stringify(item));
		},

		// スマートバナー初期化
		initSmartBanner() {
			if (this.isYappli) return;

			new SmartBanner({
				daysHidden: 0,   // days to hide banner after close button is clicked (defaults to 15)
				daysReminder: 0, // days to hide banner after "VIEW" button is clicked (defaults to 90)
				appStoreLanguage: 'ja', // language code for the App Store (defaults to user's browser language)
				title: 'ラーメン山岡家公式アプリ',
				author: 'Maruchiyo Yamaokaya, Inc.',
				button: '開く',
				store: {
					ios: 'On the App Store',
					android: 'In Google Play',
					windows: 'In Windows store'
				},
				price: {
					ios: 'FREE',
					android: 'FREE',
					windows: 'FREE'
				}
				// , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
				// , icon: '' // full path to icon image if not using website icon image
				// , force: 'ios' // Uncomment for platform emulation
			});
		}
	},

	created() {
		this.setUuidToStorage();
	},

	mounted() {
		this.initSmartBanner();
		// console.log(this.result);
	},
}
</script>